import { Modal, useFetch } from "@4uhub/lib4uhub";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Grid,
  Typography,
  CircularProgress,
  Divider,
} from "@mui/material";

import { IImportListContactsModal } from "./models";
import { IListImportContact } from "../../../../../../models/list-import-contacts";
import { getListImportContactById } from "../../../../../../services/listImportContacts.service";

const formatDate = (value: string | number) => {
  if (typeof value !== "string") return String(value);
  const formatedValue = value.slice(0, 10);
  const date = new Date(formatedValue + "T00:00:00");
  if (!isNaN(date.getTime())) {
    return date.toLocaleDateString("pt-BR");
  }
  return value;
};

const translationPath = "page.4uDlist.listContacts.modal.";

export const ImportListContactsModal = ({
  contactId,
  showModal,
  onClose,
}: IImportListContactsModal) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [listContact, setListContact] = useState<IListImportContact | null>(
    null
  );
  const { sendRequest: getListContact } = useFetch(getListImportContactById);

  const listContactKeys = useMemo(
    () =>
      (listContact
        ? Object.keys(listContact)
        : []) as (keyof IListImportContact)[],
    [listContact]
  );

  const handleOnClose = useCallback(() => {
    setListContact(null);
    onClose();
  }, [onClose]);

  const fetchListContact = useCallback(async () => {
    if (!contactId) return;
    const { data, success } = await getListContact(contactId);
    if (success) {
      setListContact(data);
    }
    setLoading(false);
  }, [contactId, getListContact]);

  useEffect(() => {
    if (contactId && showModal) {
      fetchListContact();
    } else {
      setLoading(true);
    }
  }, [contactId, showModal, fetchListContact]);

  return (
    <Modal
      open={showModal}
      onClose={handleOnClose}
      maxDialogWidth="lg"
      title={t(translationPath + "title") || "Contact Details"}
      children={
        <Box
          sx={{
            width: "100%",
            minHeight: "400px",
            // height: "90vh",
            p: 2,
            paddingTop: 4,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                flex: 1,
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2}>
              {listContactKeys.length > 0 &&
                listContactKeys.map((field, index) => {
                  const fieldName = field.replace(/([A-Z])/g, (match) => {
                    return `_${match.toLowerCase()}`;
                  });

                  if (!listContact || fieldName === "id") return;

                  const fieldValue = listContact?.[field];
                  if (typeof fieldValue === "object")
                    console.log(fieldName + ": " + fieldValue);
                  const text =
                    typeof fieldValue === "object"
                      ? fieldValue
                        ? fieldValue.name
                        : "-"
                      : typeof fieldValue === "boolean"
                      ? fieldValue
                        ? t(translationPath + "enable")
                        : t(translationPath + "disable")
                      : formatDate(fieldValue);

                  return (
                    <Grid
                      item
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      xs={12}
                      sm={6}
                      md={4}
                      key={index}
                    >
                      <Typography variant="subtitle2" color="text.secondary">
                        {`${t(translationPath + fieldName) || fieldName}: `}
                      </Typography>
                      <Typography title={text} variant="body1">
                        {text}
                      </Typography>
                      <Divider sx={{ mt: 1 }} />
                    </Grid>
                  );
                })}
            </Grid>
          )}
        </Box>
      }
    />
  );
};
